import { useQuery } from '@tanstack/react-query'
import { getFileSectionContent } from '../api/data-connectors/get-file-section-content'

/**
 * Fetches section-specific preview HTML content by section id.
 */
export function useGetFileSectionContent(
  { fileId, sectionId }: { fileId: string; sectionId: string },
  enabled: boolean
) {
  return useQuery({
    queryKey: ['file-section-content', fileId, sectionId],
    queryFn: () => getFileSectionContent(fileId, sectionId),
    enabled,
    staleTime: 1_200_000,
  })
}
